import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { LoginComponent } from './pages/auth/components/login/login.component';
import { AddEditAuthorsComponent } from './pages/dashboard/components/add-edit-authors/add-edit-authors.component';
import { AddEditBlogComponent } from './pages/dashboard/components/add-edit-blog/add-edit-blog.component';
import { AddEditNewsComponent } from './pages/dashboard/components/add-edit-news/add-edit-news.component';
import { AddEditUserComponent } from './pages/dashboard/components/add-edit-user/add-edit-user.component';
import { AddEditVideoComponent } from './pages/dashboard/components/add-edit-video/add-edit-video.component';
import { AuthorsComponent } from './pages/dashboard/components/authors/authors.component';
import { BlogsComponent } from './pages/dashboard/components/blogs/blogs.component';
import { CategoriesComponent } from './pages/dashboard/components/categories/categories.component';
import { CustomerDetailsComponent } from './pages/dashboard/components/customer-details/customer-details.component';
import { CustomersComponent } from './pages/dashboard/components/customers/customers.component';
import { DashboardComponent } from './pages/dashboard/components/dashboard/dashboard.component';
import { FaqComponent } from './pages/dashboard/components/faq/faq.component';
import { ImpactPartnersComponent } from './pages/dashboard/components/impact-partners/impact-partners.component';
import { ProfileComponent } from './pages/dashboard/components/profile/profile.component';
import { SalesDashboardComponent } from './pages/dashboard/components/sales-dashboard/sales-dashboard.component';
import { UsersComponent } from './pages/dashboard/components/users/users.component';
import { VideosComponent } from './pages/dashboard/components/videos/videos.component';
import { NewsComponent } from './pages/dashboard/news/news.component';

export const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: BlogsComponent, canActivate: [authGuard] },
      {
        path: 'add-blog',
        component: AddEditBlogComponent,
        canActivate: [authGuard],
      },
      {
        path: 'edit-blog/:id',
        component: AddEditBlogComponent,
        canActivate: [authGuard],
      },
      {
        path: 'add-news',
        component: AddEditNewsComponent,
        canActivate: [authGuard],
      },
      {
        path: 'edit-news/:id',
        component: AddEditNewsComponent,
        canActivate: [authGuard],
      },
      {
        path: 'news',
        component: NewsComponent,
        canActivate: [authGuard],
      },
      {
        path: 'categories',
        component: CategoriesComponent,
        canActivate: [authGuard],
      },
      {
        path: 'faq',
        component: FaqComponent,
        canActivate: [authGuard],
      },
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [authGuard],
      },
      {
        path: 'add-user',
        component: AddEditUserComponent,
        canActivate: [authGuard],
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [authGuard],
      },
      {
        path: 'videos',
        component: VideosComponent,
        canActivate: [authGuard],
      },
      {
        path: 'add-video',
        component: AddEditVideoComponent,
        canActivate: [authGuard],
      },
      {
        path: 'edit-video/:id',
        component: AddEditVideoComponent,
        canActivate: [authGuard],
      },
      {
        path: 'authors',
        component: AuthorsComponent,
        canActivate: [authGuard],
      },
      {
        path: 'add-author',
        component: AddEditAuthorsComponent,
        canActivate: [authGuard],
      },
      {
        path: 'edit-author/:id',
        component: AddEditAuthorsComponent,
        canActivate: [authGuard],
      },
      {
        path: 'sales-dashboard',
        component: SalesDashboardComponent,
        canActivate: [authGuard],
      },
      {
        path: 'impact-partners',
        component: ImpactPartnersComponent,
        canActivate: [authGuard],
      },
      {
        path: 'customers',
        component: CustomersComponent,
        canActivate: [authGuard],
      },
      {
        path: 'customers/:id',
        component: CustomerDetailsComponent,
        canActivate: [authGuard],
      },
    ],
  },
  { path: 'login', component: LoginComponent, canActivate: [authGuard] },
  { path: '**', redirectTo: '/login' },
];
